import React, { useId } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useDeleteApiKey } from "../hooks";
import { useDisclosure } from "../../../hooks/useDisclosure";
import SoftTypography from "../../../components/SoftTypography";
import SoftButton from "../../../components/SoftButton";

/** Deletes the selected key only after the user confirms. */
const DeleteApiKey = ({ brandId, apiKeyId, prefix }) => {
  const { mutate, isLoading } = useDeleteApiKey();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const titleId = useId();
  const descriptionId = useId();

  const handleDelete = () => {
    mutate({ brandId, apiKeyId }, { onSuccess: onClose });
  };

  return (
    <>
      <SoftButton
        variant="outlined"
        color="error"
        size="small"
        onClick={onOpen}
        disabled={isLoading}
      >
        Delete
      </SoftButton>
      <Dialog
        open={isOpen}
        onClose={isLoading ? undefined : onClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
      >
        <DialogTitle id={titleId}>Delete API key?</DialogTitle>
        <DialogContent>
          <SoftTypography
            id={descriptionId}
            component="p"
            variant="body2"
            color="text"
            sx={{ mt: 2, overflowWrap: "anywhere" }}
          >
            Delete the API key with prefix <strong>{prefix}</strong>? This action cannot be undone.
          </SoftTypography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <SoftButton variant="outlined" onClick={onClose} disabled={isLoading} autoFocus>
            Cancel
          </SoftButton>
          <SoftButton
            color="error"
            onClick={handleDelete}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Delete
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

DeleteApiKey.propTypes = {
  brandId: PropTypes.string.isRequired,
  apiKeyId: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
};

export default DeleteApiKey;
